import { toast, ToastOptions } from 'react-toastify';

/**
 * Default toast configuration
 */
const defaultToastConfig: ToastOptions = {
  position: "top-center",
  autoClose: 2500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  pauseOnFocusLoss: false,
};

/**
 * Show success toast notification
 */
export const showSuccessToast = (message: string, options?: ToastOptions) => {
  toast.success(message, { ...defaultToastConfig, ...options });
};

/**
 * Show error toast notification
 */
export const showErrorToast = (message: string, options?: ToastOptions) => {
  toast.error(message, { ...defaultToastConfig, ...options });
};

/**
 * Show warning toast notification
 */
export const showWarningToast = (message: string, options?: ToastOptions) => {
  toast.warning(message, { ...defaultToastConfig, ...options });
};

/**
 * Show info toast notification
 */
export const showInfoToast = (message: string, options?: ToastOptions) => {
  toast.info(message, { ...defaultToastConfig, ...options });
};

/**
 * Show loading toast notification (doesn't auto-close)
 */
export const showLoadingToast = (message: string, options?: ToastOptions) => {
  return toast.loading(message, { ...defaultToastConfig, autoClose: false, ...options });
};

/**
 * Update an existing toast
 */
export const updateToast = (toastId: string | number, options: any) => {
  toast.update(toastId, options);
};

/**
 * Dismiss a specific toast
 */
export const dismissToast = (toastId: string | number) => {
  toast.dismiss(toastId);
};

/**
 * Dismiss all toasts
 */
export const dismissAllToasts = () => {
  toast.dismiss();
};

